import SkillsScopeContext from '../SkillsScopeContext';
import type { SkillsScopeProviderProps } from '../types';

const SkillsScopeProvider = ({ scope, children }: SkillsScopeProviderProps) => {
    return <SkillsScopeContext.Provider value={scope}>{children}</SkillsScopeContext.Provider>;
};

export default SkillsScopeProvider;
